/**
 * Builds the auth headers every assistant request carries.
 *
 * Two different credentials travel together, on purpose:
 *
 * - `Authorization: Bearer <rpt>` keeps carrying the property RPT (the UMA token obtained for the
 *   current property), which is what Witbooking APIs authorize against. Unchanged.
 * - `X-Access-Token` carries the user's plain Keycloak access token. Since Keycloak 26.5 an RPT
 *   presented back to Keycloak as the bearer of an `uma-ticket` grant is rejected AND the user's
 *   session is terminated (keycloak/keycloak#50827), so any consumer that needs to talk to
 *   Keycloak on the user's behalf must use this token instead of the RPT.
 *
 * The access token is omitted when it is missing or empty, so a request never advertises a
 * credential it does not actually have.
 *
 * Both values must be read at call time (the access token is rotated in place by keycloak-js's
 * autoRefreshToken) — never captured in a closure.
 */
export function assistantAuthHeaders(
  rpt: string,
  accessToken: string | undefined
): Record<string, string> {
  return {
    Authorization: `Bearer ${rpt}`,
    ...(accessToken ? { "X-Access-Token": accessToken } : {}),
  };
}
